import { render, staticRenderFns } from "./CiPublicationCheckbox.vue?vue&type=template&id=f2b100f0&"
import script from "./CiPublicationCheckbox.vue?vue&type=script&lang=js&"
export * from "./CiPublicationCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CiPublicationCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports